module.exports = __webpack_public_path__ + "media/assets/images/app_store_sm-eng-4eb6ecdcc36fbc4672f1fe3ec39c29c1.png";